<div class="fullscreen-loader">
    <mat-progress-spinner
        [mode]="'indeterminate'"
        [diameter]="70"
    ></mat-progress-spinner>
</div>
